'use strict';

var createMuiTheme = require('./createMuiTheme.js');

var defaultTheme = createMuiTheme();
var defaultTheme$1 = defaultTheme;

module.exports = defaultTheme$1;
